<template>
  <div>
    <Widget>
      <h2 class="page-title text-center">Detail Rencana Aksi UPT</h2>
      <p v-if="$route.params.id" class="text-center">ID Rencana Aksi: {{ $route.params.id }}</p>
      <p v-if="!rencanaAksi" class="text-center text-danger">Data Rencana Aksi UPT tidak ditemukan.</p>
      <form-wizard v-else shape="tab" color="#3498db" title="" subtitle="" @on-change="updateProgress">
        <b-button slot="prev" id="prev-rencana-aksi-upt-form" variant="primary" hidden />
        <b-button slot="next" id="next-rencana-aksi-upt-form" variant="primary" hidden />
        <b-button slot="finish" id="finish-rencana-aksi-upt-form" variant="success" hidden />

        <tab-content title="Rencana Aksi">
          <formRencanaAksi ref="formRencanaAksi" :read-only="true" :initial-data="rencanaAksi" />
        </tab-content>
        <tab-content :title="isCentralVerifier ? 'Dokumen Persiapan' : 'Dokumentasi Persiapan'">
          <formDokumentasiPersiapan ref="formDokumentasiPersiapan" :read-only="isCentralVerifier" :documents="rencanaAksi.dokumen_persiapan" />
        </tab-content>

        <div class="d-flex justify-content-between" style="padding: 14px 20px">
          <b-button v-if="progress === 1" variant="danger" @click="$router.push('/app/rencana-aksi/upt')">
            Kembali
          </b-button>
          <b-button v-else variant="primary" @click="prevForm">
            <i class="fa fa-caret-left" /> Tab Sebelumnya
          </b-button>

          <b-button v-if="progress === 1" variant="primary" @click="nextForm">
            Tab Selanjutnya <i class="fa fa-caret-right" />
          </b-button>
          <b-button v-else-if="!isCentralVerifier" variant="success" @click="submitForm">
            Simpan <i class="fa fa-check" />
          </b-button>
        </div>
      </form-wizard>
    </Widget>
  </div>
</template>

<style scoped>
:deep(.wizard-header) {
  display: none;
}

:deep(.wizard-nav li) {
  pointer-events: none;
}
</style>

<script>
import Vue from 'vue'
import Widget from '@/components/Widget/Widget'
import formRencanaAksi from './formRencanaAksi.vue'
import formDokumentasiPersiapan from './formDokumentasiPersiapan.vue'
import { Validator } from 'vee-validate'
import { isVerifikatorPusat } from '@/helper/helpernew'
import { getRencanaAksiUptById } from './mockRencanaAksiUpt'

export default {
  components: { Widget, formRencanaAksi, formDokumentasiPersiapan },
  data() {
    return {
      progress: 1,
      user: JSON.parse(localStorage.getItem('userPengendalian') || '{}'),
      rencanaAksi: getRencanaAksiUptById(this.$route.params.id),
    }
  },
  computed: {
    isCentralVerifier() {
      return isVerifikatorPusat(this.user)
    },
  },
  mounted() {
    const dictionary = {
      id: {
        messages: {
          required: (fieldName) => `${fieldName} wajib diisi`,
        },
      },
    }
    Validator.localize(dictionary)
    this.$validator.localize('id')
  },
  methods: {
    updateProgress(prevIndex, nextIndex) {
      if (nextIndex >= 0) Vue.set(this, 'progress', nextIndex + 1)
    },
    nextForm() {
      document.getElementById('next-rencana-aksi-upt-form').click()
    },
    prevForm() {
      document.getElementById('prev-rencana-aksi-upt-form').click()
    },
    async submitForm() {
      if (this.isCentralVerifier || !this.rencanaAksi) return
      if (!(await this.$refs.formDokumentasiPersiapan.validateForm())) return

      console.log({
        ...this.$refs.formRencanaAksi.getFormData(),
        ...this.$refs.formDokumentasiPersiapan.getFormData(),
      })
    },
  },
}
</script>
